<div>
    <header>
        <img :src="logo" alt="BMWGroup, BMW, MINI logos" />
    </header>
    <main>
        <slot></slot>
    </main>
    <footer>
        <router-link to="/">Hinweise</router-link>
        |
        <router-link to="/">Datenschutz</router-link>
        |
        <router-link to="/">Impressum</router-link>
    </footer>
</div>